<template>
  <!-- <div class="text-center">
    <v-snackbar v-model="popup" :timeout="timeout">
      {{ popupText }}

      <template v-slot:action="{ attrs }">
        <v-btn color="blue" text v-bind="attrs" @click="popup = false">
          Close
        </v-btn>
      </template>
    </v-snackbar> -->
  <th>
    <v-tooltip top>
      <template v-slot:activator="{ on: tooltip }">
        <v-btn
          class="mr-2 mt-1"
          elevation="2"
          fab
          small
          :loading="loading"
          color="green lighten-3"
          @click="updateTemplate"
          v-on="{ ...tooltip }"
        >
          <v-icon small>mdi-sync</v-icon>
        </v-btn>
      </template>
      <span>Обновить текущий шаблон</span>
    </v-tooltip>
  </th>
</template>

<script>
import api from "../config/api";
import { mapGetters, mapActions } from "vuex";

export default {
  data: () => ({
    dialog: false,
    url: "/templates/update_template/",
    popup: false,
    popupText: "",
    timeout: 2,
    loading: false,
  }),

  methods: {
    ...mapGetters(["getSettings", "getCurrentTemplate"]),
    ...mapActions(["setTemplateChanged", "fetchUserTemplates"]),

    updateTemplate: function () {
      // console.log("Updating template...");
      var settings = this.getSettings();
      var name = this.getCurrentTemplate();
      this.loading = true;
      api
        .post(this.url, { settings, name })
        .then((response) => {
          // console.log("response:" + JSON.stringify(response.data));
          response;
          this.popupText = "Шаблон успешно обновлён";
          this.popup = true;
        })
        .catch((error) => {
          console.log(error.data);
        });
      this.loading = false;
      this.setTemplateChanged({ value: false });
      this.fetchUserTemplates();
    },
  },
};
</script>

<style scoped></style>

